import {Injectable} from '@angular/core';
//import {Http, RequestOptions, Headers, URLSearchParams} from '@angular/http';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
//import {Observable} from 'rxjs/Observable';
import {Observable,of} from 'rxjs';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/observable/throw';
import { urls } from '../../common/model/properties';
import { ConfigProvider } from '../../shared/services/configprovider';
import { catchError, map } from 'rxjs/operators';
import { SecureStorageService } from '../../secure-storage.service';


@Injectable()
export class providerDataUpdateService {
providerList: any;
 props:any;
    constructor(private http: HttpClient,
    private secureStorage:SecureStorageService,
        private configProvider:ConfigProvider) { 
            this.props = configProvider.getProps();
        }


    

   //   getProviderDetails(userId):Observable<any>{
   //      const headers = new Headers();
   //      headers.set('Content-Type', 'application/json');
   //      let myParams = new URLSearchParams();
   //      myParams.append('memberUid', userId);
   //      return this.http.get(urls.majorStatusChange, { headers: headers, params: myParams });
   //   }
   
     async getAddress(id): Promise<any> {
      const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
      const headers = new HttpHeaders({
        'Authorization': 'Bearer ' +  ppjwt.access_token,
        'Content-Type': 'application/json',
        'Allow-Access-Control-Origin': '*'
      });

      
      const providerList = {
        "ProviderIDList": [id]
      };
     let myParams = new HttpParams()     
     .append('memberUid', this.providerList);
      return this.http.post(urls.getProviderAddress,providerList,{headers: headers}).toPromise();
   }
   
   getLanguageAndAOEDetails():Observable<any>{
    const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
    const headers = new HttpHeaders({
      'Accept': 'application/json' ,
      'Authorization': 'Bearer ' + ppjwt.access_token
    });
    // let myParams = new HttpParams()
    // .append('memberId', id);
    return this.http.get(urls.getlanguageandaoedetailsfrompods, { headers: headers}).pipe(catchError((error) => {
      // console.log(error);
      return of(({ error: error }));
  }));         
  

  }

  GetProviderDetailsFromEDH():Observable<any>{
    const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
    const headers = new HttpHeaders({
      'Accept': 'application/json' ,
      'Authorization': 'Bearer ' + ppjwt.access_token
    });
    return this.http.get(urls.GetProviderDetailsFromEDH, { headers: headers}).pipe(catchError((error) => {
      return of(({ error: error }));
  }));         
 
  }

  savePDMDetails(pdmDetails){
    const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
    const headers = new HttpHeaders({
      'Accept': 'application/json' ,
      'Authorization': 'Bearer ' + ppjwt.access_token
    });
    const payload = pdmDetails;
    return this.http.post(urls.submitPDMdata,payload,{headers: headers}).pipe(catchError((error) => {      
        //console.log(error);
        return of(({ error: error }));
    }));         
  }

}
